export default __webpack_public_path__ + "static/media/Restaurantpic.2f4f20ae.jpg";